import { render, staticRenderFns } from "./buy-giftcard.vue?vue&type=template&id=959ebdd4&scoped=true&lang=html&"
import script from "./buy-giftcard.vue?vue&type=script&lang=js&"
export * from "./buy-giftcard.vue?vue&type=script&lang=js&"
import style0 from "./buy-giftcard.vue?vue&type=style&index=0&id=959ebdd4&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "959ebdd4",
  null
  
)

export default component.exports